__turbopack_context__.v({
  "borderTop": "Accordion-module-scss-module__Mgz2YG__borderTop",
  "flexContainer": "Accordion-module-scss-module__Mgz2YG__flexContainer",
  "hitArea": "Accordion-module-scss-module__Mgz2YG__hitArea",
  "iconWrapper": "Accordion-module-scss-module__Mgz2YG__iconWrapper",
  "isClosed": "Accordion-module-scss-module__Mgz2YG__isClosed",
  "isOpen": "Accordion-module-scss-module__Mgz2YG__isOpen",
  "titleWrapper": "Accordion-module-scss-module__Mgz2YG__titleWrapper",
});
